import 'angular';
import '../../../components/share/share.component';
import './track_report_button.directive';
import template from './action_bar.template.html?raw';

const moduleDependencies = ['components.share'];

angular
  .module('fundingSearchApp.directives.actionBar', moduleDependencies)
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(template, template);
  }])
  .directive('actionBar', () => {
    return {
      restrict: 'E',
      templateUrl: template,
      scope: {
        report: '=',
        userPermissions: '=',
        isExpandedView: '=',
      },
    };
  });
